/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VM }                      from 'g3w-eventbus';
import ApplicationState            from "store/application";
import GUI                         from 'services/gui';
import ClickMixin                  from 'mixins/click';
import CatalogLayerLegend          from 'components/CatalogLayerLegend.vue';
import { getCatalogLayerById }     from 'utils/getCatalogLayerById';

function _setAllLayersVisible(layers) {
  layers.nodes.forEach(n => {
    if (undefined === n.id) {
      _setAllLayersVisible({ nodes: n.nodes, visible: layers.visible && n.checked });
    } else if (n.parentGroup.checked && n.checked) {
      getCatalogLayerById(n.id).setVisible(layers.visible);
    }
  });
};

const __vue_script__ = {

  /** @since 3.8.6 */
  name: 'catalog-tristate-tree',

  props : [
    'layerstree',
    'storeid',
    'legend',
    'legendplace',
    'parent_mutually_exclusive',
    'parentFolder',
    'externallayers',
    'root',
    'parent'
  ],

  components: {
    CatalogLayerLegend
  },

  mixins: [ClickMixin],

  data() {
    return {
      expanded:       this.layerstree.expanded,
      isGroupChecked: true,
      controltoggled: false,
      n_childs:       null,
      filtered:       false,
      logged:         undefined !== ApplicationState.user.id, //@since 3.10.0
    }
  },

  computed: {

    /**
     * @returns {boolean} whether to display total number of features for current layer
     *
     * @since 3.8.0
     */
    showfeaturecount() {
      return undefined !== this.layerstree.featurecount;
    },

    showLegendLayer() {
      return !this.layerstree.exclude_from_legend;
    },

    showLayerTocLegend() {
      return !this.isGroup && this.showLegendLayer && this.layerstree.geolayer;
    },

    isGroup() {
      return !!this.layerstree.nodes
    },

    legendlayerposition() {
      return (this.showLegendLayer && this.layerstree.legend) ? this.legendplace : 'tab';
    },

    showscalevisibilityclass() {
      return !this.isGroup && this.layerstree.scalebasedvisibility;
    },

    showScaleVisibilityToolip() {
      return this.showscalevisibilityclass && this.layerstree.disabled && this.layerstree.checked;
    },

    isTable() {
      return !this.isGroup && !this.layerstree.geolayer && !this.layerstree.external;
    },

    isHidden() {
      return this.layerstree.hidden && (true === this.layerstree.hidden);
    },

    selected() {
      this.layerstree.selected = (this.layerstree.disabled && this.layerstree.selected) ? false : this.layerstree.selected;
    },

    isHighLight() {
      const layer = getCatalogLayerById(this.layerstree.id) || this.layerstree;
      return !this.isGroup && ApplicationState.highlightlayers && layer && layer.isVisible() && layer.getTocHighlightable();
    },

    isInGrey() {
      return (!this.isGroup && !this.isTable && !this.layerstree.external && (!this.layerstree.visible || this.layerstree.disabled));
    },

    /**
     * @since 3.8.0
     */
    getFeatureCount() {
      return Object.values(this.layerstree.featurecount).reduce((total, categoryFeatureCount) => total + 1 * categoryFeatureCount, 0);
    },

  },

  watch: {

    'layerstree.checked'() {
      if (this.isGroup) {
        this.handleGroupChecked(this.layerstree);
      } else {
        this.handleLayerChecked(this.layerstree);
      }
    }

  },

  methods: {

    /**
     * Remove current active filter
     *
     * @since 3.9.0
     */
    removeCurrentFilter() {
      return getCatalogLayerById(this.layerstree.id).deleteFilterToken();
    },

    /**
     * Handle change checked property of group
     *
     * @param {boolean} group.checked
     * @param {uknown}  group.parentGroup
     * @param {uknown}  group.nodes
     */
    handleGroupChecked(group) {

      if (!group.checked) {
        group.nodes.forEach(n => {
          if (undefined === n.id) {
            _setAllLayersVisible({ nodes: n.nodes, visible: false });
          } else if (n.checked) {
            getCatalogLayerById(n.id).setVisible(false);
          }
        });
        return; // NB exit early!
      }

      const visible            = group.parentGroup ? group.parentGroup.checked : true;
      const mutually_exclusive = group.parentGroup && group.parentGroup.mutually_exclusive;

      if (!mutually_exclusive) {
        _setAllLayersVisible({ nodes: group.nodes, visible });
      }

      if (mutually_exclusive) {
        group.parentGroup.nodes.forEach(n => {
          n.checked = n.groupId === group.groupId;
          if (n.checked) {
            _setAllLayersVisible({ nodes: n.nodes, visible });
          }
        });
      }

      // traverse parent groups
      let g = group.parentGroup;
      while (g) {
        g.checked = g.root || g.checked;
        g         = g.parentGroup;
      }
    },

    /**
     * Handle changing checked property of layer
     *
     * @param {boolean} layer.checked
     * @param {string}  layer.id
     * @param {boolean} layer.disabled
     * @param {boolean} layer.projectLayer
     * @param {uknown}  layer.parentGroup
     */
    handleLayerChecked(layer) {

      const map = GUI.getService('map'); 

      // external layer (eg. temporary layer through `addlayerscontrol`)
      if (!layer.projectLayer) {
        layer.visible = layer.checked;
        layer.setVisible(layer.checked);
        map.emit('change-layer-visibility', { id: layer.id, visible: layer.checked });
        return;  // NB exit early!
      }

      // project layer (eg. qgis layer)
      const qlayer  = getCatalogLayerById(layer.id);
      const checked = layer.checked;

      qlayer.setVisible(checked ? !layer.disabled : false)

      if (checked && layer.parentGroup.mutually_exclusive) {
        layer.parentGroup.nodes.forEach(n => n.checked = n.id === layer.id);
      }

      // traverse parent groups
      let g = layer.parentGroup;
      while (checked && g) {
        g.checked = true;
        g         = g.parentGroup;
      }

      VM.$emit('treenodevisible', qlayer);
    },

    /**
     * Save layer filter
     *
     * @since 3.9.0
     */
    saveFilter(layerstree) {
      getCatalogLayerById(layerstree.id).saveFilter();
    },

    /**
     * @fires VM~activefiltertokenlayer
     */
    toggleFilterLayer() {
      VM.$emit('activefiltertokenlayer', this.storeid, this.layerstree);
    },

    /**
     * @fires VM~unselectionlayer
     */
    clearSelection() {
      VM.$emit('unselectionlayer', this.storeid, this.layerstree);
    },

    toggle() {
      this.layerstree.checked = !this.layerstree.checked;
    },

    expandCollapse() {
      this.layerstree.expanded = !this.layerstree.expanded;
    },

    /**
     * Select legend item
     *
     * @fires VM~treenodeselected
     */
    select() {
      // `undefined === selected` means unselectable layer (eg. external/temporary  WMS)
      if (
        undefined !== this.layerstree.selected &&
        ((!this.isGroup && !this.isTable) || (this.layerstree.external && false === this.layerstree.projectLayer))
      ) {
        VM.$emit('treenodeselected', this.layerstree);
      }
    },

    /**
     * @TODO refactor this, almost the Same as `CatalogContextMenu.vue::zoomToLayer(layer)`
     *
     * @since 3.10.0
     */
    maybeZoomToLayer(layer) {
      if (this.canZoom(this.layerstree)) {
        GUI
          .getService('map')
          .goToBBox(
            [layer.bbox.minx, layer.bbox.miny, layer.bbox.maxx, layer.bbox.maxy],
            layer.epsg
          );
      }
    },

    /**
     * @TODO refactor this, almost the same as: `CatalogContextMenu.vue::canZoom(layer))`
     *
     * @since v3.8
     */
    canZoom(layer) {
      return (layer.bbox && [layer.bbox.minx, layer.bbox.miny, layer.bbox.maxx, layer.bbox.maxy].find(coordinate => coordinate > 0));
    },

    /**
     * Handle `click` and `doubleclick` click events on a single tree item (TOC).
     *
     * 1 = select legend item
     * 2 = zoom to layer bounds
     *
     * @since v3.8
     */
    onTreeItemClick() {
      this.handleClick({
        '1': () => !this.isTable && !this.isGroup && this.select(),
        '2': () => !this.isTable && this.maybeZoomToLayer(this.layerstree)
      }, this);
    },

    triClass() {
      return this.g3wtemplate.getFontClass(this.layerstree.checked ? 'check' : 'uncheck');
    },

    removeExternalLayer(name) {
      GUI.getService('map').removeExternalLayer(name);
    },

    /**
     * @param evt
     * 
     * @fires VM~context-menu
     * 
     * @since 3.10.0
     */
    showContextMenu(evt) {
      VM.$emit('context-menu', evt, this.layerstree);
    },

  },

  /**
   * Inizialize layer (disable, visible etc..)
   */
  created() {
    if (this.isGroup && !this.layerstree.checked) {
      this.handleGroupChecked(this.layerstree);
    }
    if (this.isGroup && !this.root && this.parent_mutually_exclusive && !this.layerstree.mutually_exclusive) {
      this.layerstree.nodes.forEach(node => { node.id && (node.uncheckable = true); })
    }
  },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isGroup || !_vm.layerstree.projectLayer || _vm.layerstree.toc)?_c('li',{staticClass:"tree-item",class:{
    selected:         !_vm.isGroup || !_vm.isTable ? _vm.layerstree.selected : false,
    itemmarginbottom: !_vm.isGroup,
    disabled:         _vm.isInGrey,
    group:            _vm.isGroup
  },style:({
    marginLeft: !_vm.isGroup ? '5px' : '0',
    position: 'relative',
  }),on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showContextMenu.apply(null, arguments)},"click":function($event){$event.stopPropagation();return _vm.onTreeItemClick.apply(null, arguments)}}},[(_vm.isGroup)?_c('span',{staticClass:"root collapse-expande-collapse-icon",class:[
      { bold : _vm.isGroup },
      _vm.g3wtemplate.getFontClass(_vm.layerstree.expanded ? 'caret-down' : 'caret-right')
    ],staticStyle:{"padding-right":"2px"},on:{"click":function($event){$event.stopPropagation();return _vm.expandCollapse.apply(null, arguments)}}}):_vm._e(),_vm._v(" "),(_vm.isGroup)?_c('span',{class:[_vm.triClass()],staticStyle:{"color":"#ffffff"},on:{"click":function($event){$event.stopPropagation();return _vm.toggle()}}}):(_vm.isTable)?_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.layerstree.hidden),expression:"!layerstree.hidden"}],class:[
      _vm.parentFolder ? 'child' : 'root',
      _vm.g3wtemplate.getFontClass('table')
    ],staticStyle:{"padding-left":"18px"}}):[(_vm.layerstree.external && _vm.layerstree.removable)?_c('span',{class:_vm.g3wtemplate.getFontClass('trash'),staticStyle:{"color":"red","padding-left":"1px"},on:{"click":function($event){$event.stopPropagation();return _vm.removeExternalLayer(_vm.layerstree.name, _vm.layerstree._type)}}}):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.layerstree.hidden),expression:"!layerstree.hidden"}],staticClass:"checkbox-layer",class:_vm.parentFolder ? 'child' : 'root'},[('toc' === _vm.legendlayerposition || !_vm.isGroup && _vm.layerstree.categories)?_c('span',{staticClass:"collapse-expande-collapse-icon",class:_vm.g3wtemplate.getFontClass(_vm.layerstree.visible && _vm.layerstree.expanded ? 'caret-down' : 'caret-right'),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }$event.stopPropagation();return _vm.expandCollapse.apply(null, arguments)}}}):_vm._e(),_vm._v(" "),_c('span',{class:[
          _vm.g3wtemplate.getFontClass(_vm.layerstree.checked ? 'check': 'uncheck'),
          { 'toc-added-external-layer': (!_vm.layerstree.legend && _vm.layerstree.external) }
        ],style:({
          paddingLeft: ('toc' === _vm.legendlayerposition)
            ? '5px'
            : !_vm.isGroup && _vm.layerstree.categories
              ? '5px'
              : (!_vm.layerstree.legend && _vm.layerstree.external)
                ? '1px'
                : '18px'
        }),on:{"click":function($event){$event.stopPropagation();return _vm.toggle()}}})])],_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.layerstree.hidden || _vm.isGroup),expression:"!layerstree.hidden || isGroup"}],staticClass:"tree-node-title",class:{
      disabled: !_vm.layerstree.external && (_vm.layerstree.disabled || (_vm.layerstree.id && !_vm.layerstree.visible)),
      bold: _vm.isGroup
    }},[_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create.text",value:(_vm.showScaleVisibilityToolip ? ("minscale:" + (_vm.layerstree.minscale) + " - maxscale:" + (_vm.layerstree.maxscale)) : ''),expression:"showScaleVisibilityToolip ? `minscale:${layerstree.minscale} - maxscale:${layerstree.maxscale}` : ''",arg:"top",modifiers:{"create":true,"text":true}}],staticClass:"g3w-long-text",class:{
        highlightlayer:  _vm.isHighLight,
        scalevisibility: _vm.showscalevisibilityclass
      },attrs:{"current-tooltip":_vm.showScaleVisibilityToolip ? ("minscale:" + (_vm.layerstree.minscale) + " - maxscale: " + (_vm.layerstree.maxscale)) : ''}},[(!_vm.isGroup && !_vm.layerstree.external && null !== _vm.layerstree.filter.current)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create.text",value:(_vm.layerstree.filter.current.name),expression:"layerstree.filter.current.name",arg:"top",modifiers:{"create":true,"text":true}}],staticStyle:{"cursor":"pointer"},attrs:{"current-tooltip":_vm.layerstree.filter.current.name},on:{"click":function($event){$event.stopPropagation();return _vm.removeCurrentFilter.apply(null, arguments)}}},[_c('span',{class:_vm.g3wtemplate.getFontClass('filter'),staticStyle:{"color":"red"}})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.layerstree.title))]),_vm._v(" "),(!_vm.isGroup && _vm.showfeaturecount)?_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("\n        ["+_vm._s(_vm.getFeatureCount)+"]\n      ")]):_vm._e()]),_vm._v(" "),((!_vm.isGroup && _vm.layerstree.selection))?_c('div',[(_vm.layerstree.selection.active)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip.create",value:('layer_selection_filter.tools.clear'),expression:"'layer_selection_filter.tools.clear'",modifiers:{"create":true}}],staticClass:"action-button skin-tooltip-left selection-filter-icon",class:_vm.g3wtemplate.getFontClass('clear'),attrs:{"data-placement":"left","data-toggle":"tooltip","data-container":"body"},on:{"click":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"caputure",undefined,$event.key,undefined)){ return null; }$event.preventDefault();$event.stopPropagation();return _vm.clearSelection.apply(null, arguments)}}}):_vm._e(),_vm._v(" "),(!_vm.layerstree.external && (_vm.layerstree.selection.active || _vm.layerstree.filter.active) && !_vm.layerstree.filter.pagination)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip.create",value:('layer_selection_filter.tools.filter'),expression:"'layer_selection_filter.tools.filter'",modifiers:{"create":true}}],staticClass:"action-button skin-tooltip-left selection-filter-icon",class:[
          _vm.g3wtemplate.getFontClass('filter'),
          _vm.layerstree.filter.active  ? 'active' : '' ],attrs:{"data-placement":"left","data-toggle":"tooltip","data-container":"body"},on:{"click":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"caputure",undefined,$event.key,undefined)){ return null; }$event.preventDefault();$event.stopPropagation();return _vm.toggleFilterLayer.apply(null, arguments)}}}):_vm._e(),_vm._v(" "),(_vm.logged && !_vm.layerstree.external && (_vm.layerstree.selection.active && _vm.layerstree.filter.active))?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip.create",value:('layer_selection_filter.tools.savefilter'),expression:"'layer_selection_filter.tools.savefilter'",modifiers:{"create":true}}],staticClass:"action-button skin-tooltip-left selection-filter-icon",class:_vm.g3wtemplate.getFontClass('save'),attrs:{"data-placement":"left","data-toggle":"tooltip"},on:{"click":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"caputure",undefined,$event.key,undefined)){ return null; }$event.preventDefault();$event.stopPropagation();return _vm.saveFilter(_vm.layerstree)}}}):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.showLayerTocLegend)?_c('catalog-layer-legend',{attrs:{"legendplace":_vm.legendplace,"layer":_vm.layerstree}}):_vm._e(),_vm._v(" "),(_vm.isGroup)?_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.layerstree.expanded),expression:"layerstree.expanded"}],staticClass:"tree-content-items group",class:[("g3w-lendplace-" + _vm.legendplace)]},_vm._l((_vm.layerstree.nodes),function(_layerstree){return _c('span',{key:_layerstree.id || _layerstree.groupId},[_c('catalog-tristate-tree',{attrs:{"root":false,"legendConfig":_vm.legend,"legendplace":_vm.legendplace,"parentFolder":_vm.isGroup,"layerstree":_layerstree,"storeid":_vm.storeid,"parent":_vm.layerstree,"parent_mutually_exclusive":!!_vm.layerstree.mutually_exclusive}})],1)}),0):_vm._e(),_vm._v(" "),(!_vm.isGroup)?_c('a',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('catalog_items.helptext'),expression:"'catalog_items.helptext'",arg:"left",modifiers:{"create":true}}],class:'toggle-context-menu ' + _vm.$fa('ellips-v'),attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showContextMenu.apply(null, arguments)}}}):_vm._e()],2):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "CatalogTristateTree.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__